export {getUrlMeta};

async function getUrlMeta (url) {
    let response = await fetch('https://the-wallet-server-60010051318.catalystserverless.in/server/url_meta_function/?targetUrl=' + encodeURIComponent(url));
    let data = await response.json();
    console.debug(data);
    if (response.status == 200) {
        let imgUrl = data.imgUrl;
        let title = data.title;
        let description = data.description;
        let imgData = data.imgData;
        
        let result = {imgUrl, title, description, imgData};
        result.success = true;
        return result;
    } else {
        let msg = data.msg;
        let errorMsg = data.errorMsg;
        console.warn('Unable to process URL ' + url);
        console.warn({msg, errorMsg});
        let result = {errorMsg};
        result.success = false;
        return result;
    }
  }